export const products = [
    {
        id: 1,
        name: "Shake Shack Burger",
        price: 15.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/products/burgirr.jfif"
    },
    {
        id: 2,
        name: "Bubble Tea",
        price: 10.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/products/bubble_tea.jpg"
    },
    {
        id: 3,
        name: "Issac Toast",
        price: 10.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/products/issac_toast.jpg"
    },
    {
        id: 4,
        name: "Premium Chocolates",
        price: 20.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/products/choco.jpg"
    },
    {
        id: 5,
        name: "Ramen",
        price: 50.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/products/ramen.jpg"
    },
    {
        id: 6,
        name: "Riverside Grilled Fish",
        price: 689.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/products/fish.jfif"
    }
]